import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { getReconciliationMerchants } from 'config/requests/reconciliation';

export function useReconciliationMerchants() {
  return useQuery({
    queryKey: [Resources.ReconciliationMerchants],
    queryFn: getReconciliationMerchants,
  });
}
